import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../utils/api';
import AuthCard, { PasswordRequirements } from '../components/AuthCard';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const submit = async (event) => {
    event.preventDefault();
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const response = await api.resetPassword(token, password);
      setMessage(response.data.message);
    } catch (requestError) {
      setError(requestError.response?.data?.detail || 'Unable to reset password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard title="Set a new password" description="Your reset link can be used once. Completing this step signs out any older Cloud Watcher sessions.">
      {!token ? (
        <div role="alert" className="rounded-lg border border-red-500/20 bg-red-500/10 p-4 text-sm text-red-300">This reset link is incomplete.</div>
      ) : message ? (
        <div role="status" className="rounded-lg border border-emerald-500/20 bg-emerald-500/10 p-4 text-sm text-emerald-300">{message}</div>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label htmlFor="reset-password" className="block text-xs font-medium text-zinc-500 mb-2 uppercase tracking-wider">New password</label>
            <input id="reset-password" type="password" autoComplete="new-password" value={password} onChange={(event) => setPassword(event.target.value)} required className="w-full px-4 py-3 bg-zinc-900 border border-zinc-800 rounded-lg text-zinc-100 focus:border-amber-500/50 outline-none" />
          </div>
          <div>
            <label htmlFor="reset-confirm" className="block text-xs font-medium text-zinc-500 mb-2 uppercase tracking-wider">Confirm new password</label>
            <input id="reset-confirm" type="password" autoComplete="new-password" value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} required className="w-full px-4 py-3 bg-zinc-900 border border-zinc-800 rounded-lg text-zinc-100 focus:border-amber-500/50 outline-none" />
          </div>
          <PasswordRequirements />
          {error && <p role="alert" className="text-sm text-red-400">{error}</p>}
          <button disabled={loading} className="w-full py-3.5 bg-gradient-to-r from-amber-500 to-amber-600 text-zinc-900 rounded-lg font-semibold disabled:opacity-50">{loading ? 'Resetting…' : 'Reset password'}</button>
        </form>
      )}
      <Link to="/auth" className="mt-6 block text-center text-sm text-amber-400 hover:text-amber-300">Return to sign in</Link>
    </AuthCard>
  );
};

export default ResetPassword;
